import { withStyles } from "@material-ui/core";
import React from "react";
import DataGrid from "../../../../dataGrid";
import StatusBar from "../../../../dataGrid/StatusBar";
import GridHeader from "../../components/GridHeader";
import GridConfig from "./gridConfig";
import { isEqual } from "lodash";
import { getSpecialNeeds } from "../../../utils";
import { compose } from 'recompose';
import { withAppConfig } from "../../../../../appConfigContext";
import styles from "../../common/GridStyles";
class ReturnsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
    };
    this.gridConfig = new GridConfig({
      userConfig: this.props.userProfile?.columnPref,
      columnConfig: this.props.configJSON?.gridColumnConfig,
      terminal: this.props.userProfile?.terminal.code,
    });
    this.gridContext = {
      specialNeedsOptions: getSpecialNeeds(this.props.serviceLevelList),
    };
  }

  componentDidMount() {
    this.props.glEventHub.on("returnsGrid", this.onSearchTextChanged);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.serviceLevelList, this.props.serviceLevelList)) {
      this.gridContext = {
        specialNeedsOptions: getSpecialNeeds(this.props.serviceLevelList),
      };
    }
  }

  componentWillUnmount() {
    this.props.glEventHub.off("returnsGrid", this.onSearchTextChanged);
  }

  onSearchTextChanged = (searchText) => {
    this.setState({
      searchText,
    });
  };

  constructStatusBar = (filteredData) => {
    return [
      {
        label: filteredData.length + " Returns",
        filterCondition: "",
      },
    ];
  };

  isRowSelectable = (params) => {
    return !params.data.isInPlan;
  };

  render() {
    const { config } = this.gridConfig;
    const { classes, ...rest } = this.props;
    return (
      <div className={`${classes.dataGrid} ${classes.gridContent}`}>
        <GridHeader
          title="Returns"
          headerId="returnsGrid"
          glEventHub={this.props.glEventHub}
        />
        <DataGrid
          defaultColDef={config.defaultColDef}
          columnDefs={config.columns}
          config={config}
          rowSelection={config.rowSelection}
          rowDeselection={config.rowDeselection}
          deltaRowDataMode={true}
          quickFilterText={this.state.searchText}
          suppressRowClickSelection
          panelLabel={(filteredData) => (
            <StatusBar data={this.constructStatusBar(filteredData)} />
          )}
          context={this.gridContext}
          rowClassRules={config.rowClassRules}
          isRowSelectable={this.isRowSelectable}
          getRowNodeId={(data) => data.proId}
          {...rest}
        />
      </div>
    );
  }
}

export default compose(withAppConfig, withStyles(styles))(ReturnsGrid);
